<template>
    <div>
        <ec-tabela-listagem
            ref="listagem"
            :url-sistema="urlSistema"
            rotulo-itens="unidades"
            texto-vazio="Nenhuma unidade cadastrada."
            placeholder-busca="Buscar por unidade, empresa ou CNPJ"
            :colunas-extras="1"
            :link-linha="pessoa => '/Access/Unity/Unitie/' + pessoa.id"
        >
            <template v-slot:botaonovo>
                <slot name="botaonovo"></slot>
            </template>

            <template v-slot:cabecalho-antes>
                <th class="text-left">Empresa Vinculada</th>
            </template>

            <template v-slot:celulas-antes="{ item }">
                <td class="text-left" data-label="Empresa Vinculada">
                    <span v-if="item.companies" class="ec-tabela__principal">{{ item.companies.nomecompleto }}</span>
                    <small v-if="item.companies" class="ec-tabela__secundario">Empresa {{ item.companies.codigoempresa }}</small>
                </td>
            </template>

            <template v-slot:acoes="{ item }">
                <a :href="'/Access/Unity/Unitie/'+item.id" class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Acessar unidade" aria-label="Acessar unidade"><b-icon icon="box-arrow-in-right"></b-icon></a>
                <a v-if="visualizar" :href="urlSistema+'/'+item.id" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Visualizar cadastro" aria-label="Visualizar cadastro"><b-icon icon="eye-fill"></b-icon></a>
                <a v-if="editar" :href="urlSistema+'/'+item.id+'/edit'" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Editar" aria-label="Editar"><b-icon icon="pencil-fill"></b-icon></a>
                <button v-if="excluir" type="button" class="btn btn-sm ec-acao ec-acao--perigo" v-b-tooltip.hover title="Excluir" aria-label="Excluir" @click="selecionarPessoaExcluir(item)"><b-icon icon="trash-fill"></b-icon></button>
            </template>
        </ec-tabela-listagem>

        <company-unity-modal-exclusao @exclusaoconcluida="$refs.listagem.recarregar()" v-if="pessoaSelecionada" id="ExclusaoPessoa" :url-redirect="'/'+urlSistema+'/'" :url-sistema="urlSistema" :pessoa="pessoaSelecionada" :sem-padding="true">
            <template v-slot:titulo>
                EXCLUSÃO DE UNIDADE
            </template>
        </company-unity-modal-exclusao>
    </div>
</template>

<script>
export default {
    props:
    {
        urlSistema:{type:String,required:true},
        novo:{type:Boolean,required:true},
        visualizar:{type:Boolean,required:true},
        editar:{type:Boolean,required:true},
        excluir:{type:Boolean,required:true},
        classe:{
            type:String,
            required:false
        }
    },
    data(){
        return{
            pessoaSelecionada:{},
        }
    },
    methods:{
        selecionarPessoaExcluir(pessoa){
            this.pessoaSelecionada = pessoa
            $('#ExclusaoPessoa').modal('show');
        },
    }
}
</script>
